var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-aside',{staticClass:"ms-aside-container",style:({'margin-left': !_vm.asideHidden ? 0 : '-' + _vm.width}),attrs:{"width":_vm.width}},[_vm._t("default"),(_vm.showDragBar)?_c('de-horizontal-drag-bar'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }